const T = "HTTP";
export {
  T as HTTP
};
